import React from 'react';

import './styles.scss';

const MenuItem = (props) => {
  const {
    item: { icon = '', text = '', key = '' },
    index = '',
    menuChosen = '',
  } = props;

  const chosenStyle = {
    backgroundColor: '#fbfbfb',
    borderTopLeftRadius: '10px',
    borderBottomLeftRadius: '10px',
    border: '1px solid #5da6df',
    borderRight: '3px solid #fbfbfb',
    position: 'relative',
    left: '2.2px',
  };

  return (
    <div className="mo__menu-item" key={index} style={key === menuChosen ? chosenStyle : {}}>
      {React.isValidElement(icon) ? icon : <img alt="" src={icon} />}
      <span className="text">{text}</span>
    </div>
  );
};

export default MenuItem;
